<template>
  <div>
    <b-row style="margin-top: 25px;">
      <b-col sm="3">
        <video
            style="border-radius: 15px; border: yellow;border-width: 5px"
            width="250"
            height="250"
            controls
        >
          <source :src="videoURL" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <h2>{{deviceName}}</h2>
          </b-col>
          <b-col>
            <h5 class="float-right">
              <date-format-toggle
              :date="createdAt"
              />
            </h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h4>Grandma</h4>
          </b-col>
          <b-col>
            <h5 class="float-right">
              {{ trigger }}
            </h5>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateFormatToggle from "@/components/common/dateFormatToggle";
export default {
  name: "Display_VideoRow",
  components: {
    DateFormatToggle
  },
  created(){},
  mounted() {},
  props: {
    video: {
      type: Object,
      required: false,
      default: () => {}
    },
    output: {
      type: Object,
      required: false,
      default: () => {}
    },
    settings: {
      type: Object,
      required: false,
      default: () => {}
    },
    userData: {
      type: Object,
      required: false,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplayActivity: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplaySettings: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    videoURL(){
      return this.video && this.video.video && this.video.video.videoURL ?
          this.video.video.videoURL : null;
    },
    trigger(){
      return this.video && this.video.video && this.video.video.trigger ?
          this.video.video.trigger : null;
    },
    deviceName(){
      return this.video && this.video.deviceName ?
          this.video.deviceName : null;
    },
    createdAt(){
      return this.video && this.video._created_at ?
          this.video._created_at : null;
    },
    input(){
      return ""
    }
  },
  methods: {
    handleGenerateClick(){
      this.$emit("generate-click", this.input)
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
